import capsFetcher from '../../shared/capsFetcher';

const fetcher = async (config) => capsFetcher({
  method: 'POST',
  ...config,
});

export default fetcher;
